module.exports = __webpack_public_path__ + "img/result-detail-last-message01.8dfc518e.svg";